var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('div',{staticClass:"v-note-wrapper markdown-body shadow",attrs:{"data-v-7a63e4b3":""}},[_c('h3',[_c('a',{attrs:{"id":"_0"}}),_vm._v("表格行权限")]),_c('p',[_vm._v("如何控制表格的数据对哪些人有可读权限？")]),_c('p',[_vm._v("参照 "),_c('a',{attrs:{"href":"/#/doc/detail/1585460201252515842/1585462259011612674"}},[_vm._v("数据权限")])])])])
}]

export { render, staticRenderFns }